import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RestoreClinicStore } from './restore-clinic.store';
import { LoadingStatus } from '../../shared/enums/loading';

@Component({
  selector: 'anihis-restore-clinic',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './restore-clinic.component.html',
  styleUrl: './restore-clinic.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RestoreClinicStore],
})
export class RestoreClinicComponent implements OnInit {
  store = inject(RestoreClinicStore);
  private route = inject(ActivatedRoute);

  readonly status = LoadingStatus;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const clinicUid = params['clinicUid'] ?? '';
      const token = params['token'] ?? '';

      this.store.restoreClinic(clinicUid, token).subscribe();
    });
  }
}
